import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { ConfirmationService } from 'primeng/api';
import { LicenseStudyAreas } from 'src/app/predictor-enterprise-license/shared/interface/License-Study-Areas';
import { LicenseStudyAreaServiceService } from 'src/app/predictor/services/license-study-area-service.service';
import { LicenseStudyAreaActions } from 'src/app/state/License-Study-Area/license-study-area.actions';
import { timer } from 'rxjs';

@Component({
  selector: 'app-review-study-area',
  templateUrl: './review-study-area.component.html',
  styleUrl: './review-study-area.component.scss',
})
export class ReviewStudyAreaComponent implements OnInit {
  constructor(
    private readonly studyAreaService: LicenseStudyAreaServiceService,
    private readonly confirmationService: ConfirmationService,
    private readonly store: Store,
    private readonly router: Router
  ) { }

  studyAreaName: string = '';
  public currentStep = 1;
  public newDrawnArea:any = null;
  public licenseStudyAreas: LicenseStudyAreas[] = [];
  public calculatedRemainingSize: number = 0;
  studyArea: any;
  public isStudyAreaVisible: boolean = false;
  public isAvailableListClickable: boolean = false;
  licenseStudyAreaData!: LicenseStudyAreas[];

  ngOnInit() {
    this.studyAreaService.currentStep$.subscribe((step) => {
      this.currentStep = step;
    });

    this.studyAreaService.selectedStudyArea$.subscribe((area) => {
      if (area) {
        this.licenseStudyAreas[0] = area;       
      }
    });

    this.studyAreaService.getLicenseStudyAreaData().subscribe((data) => {
      this.licenseStudyAreaData = data;
    })

    this.studyAreaService.drawnAreaSource$.subscribe((drawnArea) => {
      this.newDrawnArea = drawnArea;
    });
  }

  changeStep() {
    this.studyAreaService.setStep(0);
  }

  confirmedStudyAreaPopup() {
    this.confirmationService.confirm({
      header: `Review and Confirm`,
      message: `Once created, study areas cannot be deleted. By clicking ‘Confirm’, you agree to proceed with saving your study area under these terms.`,
      accept: () => {
        this.store.dispatch(
          new LicenseStudyAreaActions.Create(this.licenseStudyAreas[0])
        );
        timer(1500).subscribe(() => {
           this.studyAreaService.setDrawnAreaDetails(null);
          this.goToHomePage();
        });
      },

      reject: () => {
        console.info('Deleting Study Area Canceled');
      },
      acceptIcon: '.',
      rejectIcon: '.',
      rejectButtonStyleClass: 'p-button-text',
      acceptButtonStyleClass: 'p-button p-button-text basin-ml-5',
      acceptLabel: 'Confirm',
      rejectLabel: 'Cancel',
    });
  }

  goToHomePage() {
    this.studyAreaService.setStep(0);
    this.studyAreaService.setDrawnAreaDetails(null);
    this.router.navigate(['/predictor']);
  }

  toggleStudyAreaPanel() {
    this.isStudyAreaVisible = !this.isStudyAreaVisible;
  }

  onStudyAreaClick(event: any) {

  }
}
